import type { IntlShape } from 'react-intl';

export const getStatusLabels = (intl: IntlShape) => {
  return {
    Active: intl.formatMessage({
      id: 'User.status.active',
      defaultMessage: 'Active',
      description: 'Label for active user status',
    }),
    Deactivated: intl.formatMessage({
      id: 'User.status.deactivated',
      defaultMessage: 'Deactivated',
      description: 'Label for deactivated user status',
    }),
    Pending: intl.formatMessage({
      id: 'User.status.pending',
      defaultMessage: 'Pending',
      description: 'Label for pending user status',
    }),
  };
};
